const TemplateAction = Object.freeze({
    DEFAULT_CLINICAL_NOTE: "Default Clinical Note",
    GENERATE_AFTER_CONVERSATION: "Generate after Conversation",
});

export default TemplateAction;